var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
export const ContextTabIndexState = React.createContext({
    activeIndex: 0,
    onTabClick: () => { }
});
const TabsSC = styled.div `
  display: block;
`;
const Tabs = (props) => {
    const { selectedIndex: selectedIndexProp, onChange, fullWidth, children: childrenProp, className: classNameProp, forwardedRef } = props, others = __rest(props, ["selectedIndex", "onChange", "fullWidth", "children", "className", "forwardedRef"]);
    const [selectedIndex, setSelectedIndex] = React.useState(Number(selectedIndexProp));
    const { current: isControlled } = React.useRef(selectedIndexProp != null);
    const onTabClick = React.useCallback((event) => {
        const eventIndex = Number(event.currentTarget.dataset.index);
        if (!isControlled) {
            if (eventIndex !== selectedIndex) {
                setSelectedIndex(Number(eventIndex));
            }
        }
        if (onChange) {
            onChange(eventIndex, event);
        }
    }, [onChange, setSelectedIndex, selectedIndex, isControlled]);
    let tabPanelLength = 0;
    const children = React.Children.map(childrenProp, (child, index) => {
        if (!React.isValidElement(child)) {
            return null;
        }
        if (index === 0) {
            return React.cloneElement(child, {
                fullWidth
            });
        }
        const TabPanelEl = React.cloneElement(child, {
            index: tabPanelLength
        });
        tabPanelLength += 1;
        return TabPanelEl;
    });
    let activeIndex = isControlled ? selectedIndexProp : selectedIndex;
    activeIndex = activeIndex || 0;
    activeIndex = Math.max(0, activeIndex);
    activeIndex = Math.min(tabPanelLength - 1, activeIndex);
    const contextValue = {
        activeIndex,
        onTabClick
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ContextTabIndexState.Provider, { value: contextValue },
            React.createElement(TabsSC, Object.assign({ className: classNameProp, ref: forwardedRef }, others), children))));
};
Tabs.propTypes = {
    selectedIndex: PropTypes.number,
    onChange: PropTypes.func,
    className: PropTypes.string,
    fullWidth: PropTypes.bool,
    children: PropTypes.node,
    forwardedRef: PropTypes.any
};
Tabs.defaultProps = {
    selectedIndex: undefined,
    onChange: undefined,
    className: undefined,
    fullWidth: false,
    children: null,
    forwardedRef: null
};
export { Tabs as TabsRootComp };
export default withForwardedRef(Tabs);
//# sourceMappingURL=Tabs.js.map